import {
  can,
  getCurrentPermissionState,
  hasScopedUserPermissions,
  isHotelFeatureAssigned,
  isModuleAssigned,
  isPermissionRelevantForHotel,
} from '../auth/permissionProvider';
import { PERMISSIONS } from '../auth/permissions';

export const getUserPermissionCodes = () => {
  return getCurrentPermissionState().userPermissions;
};

export const getSelectedHotelEnabledFeatureCodes = () => {
  return getCurrentPermissionState().hotelFeatures;
};

export const allowHotelsWithoutFeaturePackages = () => {
  return getCurrentPermissionState().allowHotelsWithoutFeaturePackages;
};

export const hasScopedFeaturePermissions = (permissionCodes = getUserPermissionCodes()) => {
  return hasScopedUserPermissions(permissionCodes);
};

export const isHotelFeatureEnabled = (
  code,
  enabledFeatureCodes = getSelectedHotelEnabledFeatureCodes(),
) => {
  return isHotelFeatureAssigned(code, {
    ...getCurrentPermissionState(),
    hotelFeatures: enabledFeatureCodes,
  });
};

export const hasFeaturePermission = (code, permissionCodes = getUserPermissionCodes()) => {
  return can(code, {
    ...getCurrentPermissionState(),
    userPermissions: permissionCodes,
  });
};

export const canAccess = hasFeaturePermission;
export const canModifyBooking = (permissionCodes = getUserPermissionCodes()) =>
  hasFeaturePermission(PERMISSIONS.BOOKING_MODIFY, permissionCodes);
export { isModuleAssigned, isPermissionRelevantForHotel, PERMISSIONS };

export const getFirstAllowedModulePath = (permissionCodes = getUserPermissionCodes()) => {
  const checks = [
    [PERMISSIONS.DASHBOARD_VIEW, '/dashboard/'],
    // Front Office has booking ops only — land on the ops calendar, not Insights dashboards.
    [PERMISSIONS.BOOKING_OPERATIONS, '/dashboard/'],
    [PERMISSIONS.CUSTOMER_MANAGE, '/customerhub/'],
    [PERMISSIONS.FINANCE_MANAGE, '/finance/'],
    [PERMISSIONS.INVENTORY_MANAGE, '/inventory/'],
    [PERMISSIONS.CONFIGURATION_MANAGE, '/configuration/'],
    [PERMISSIONS.DISTRIBUTION_MANAGE, '/distribution/'],
    [PERMISSIONS.DYNAMIC_PRICING_MANAGE, '/dynamic-pricing/'],
    [PERMISSIONS.POS_RESTAURANT_MANAGE, '/restaurant/'],
    [PERMISSIONS.HOUSEKEEPING_MANAGE, '/housekeeping/'],
    [PERMISSIONS.STOCK_MANAGE, '/stock/'],
    [PERMISSIONS.HALL_MANAGE, '/hall/dashboard/'],
    [PERMISSIONS.USERS_MANAGE, '/users/'],
  ];
  for (const [permissionCode, path] of checks) {
    if (hasFeaturePermission(permissionCode, permissionCodes)) {
      return path;
    }
  }
  return '/profile/';
};
